<div *transloco="let t">
    <h1>{{t('error_header')}}</h1>
    <div *ngIf="systemRecordsErrorMessages$ | async as errorMessages" class="overlay">
        <li *ngFor="let message of errorMessages">{{message}}</li>
    </div>
</div>
